export default __webpack_public_path__ + "static/media/mon_24.8041da21.png";